import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authService } from '../../services/auth';

const PasswordReset: React.FC = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (token) await authService.resetPassword(token, password);
      else await authService.requestPasswordReset(email);
      setMessage(t(token ? 'auth.reset.done' : 'auth.reset.sent'));
    } catch (err: any) {
      setError(err.response?.data?.message || t('auth.reset.error'));
    } finally {
      setLoading(false);
    }
  };

  return <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
    <div className="bg-white shadow rounded-lg p-8 w-full max-w-md">
      <h1 className="text-2xl font-bold mb-6">{t(token ? 'auth.reset.title' : 'auth.reset.requestTitle')}</h1>
      {message ? <p role="status" className="text-green-700 mb-4">{message}</p> : <form onSubmit={submit} className="space-y-4">
        <label className="block">{t(token ? 'auth.reset.newPassword' : 'auth.login.email')}
          <input type={token ? 'password' : 'email'} autoComplete={token ? 'new-password' : 'email'} required minLength={token ? 8 : undefined}
            value={token ? password : email} onChange={event => token ? setPassword(event.target.value) : setEmail(event.target.value)}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2" />
        </label>
        {error && <p role="alert" className="text-red-700">{error}</p>}
        <button disabled={loading} className="w-full rounded-md bg-indigo-600 text-white py-2 disabled:opacity-50">{t(token ? 'auth.reset.submit' : 'auth.reset.requestSubmit')}</button>
      </form>}
      <Link to="/login" className="block mt-6 text-indigo-600">{t('auth.reset.back')}</Link>
    </div>
  </div>;
};

export default PasswordReset;
